/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserStatus } from './UserStatus';
import {
    UserStatusFromJSON,
    UserStatusFromJSONTyped,
    UserStatusToJSON,
    UserStatusToJSONTyped,
} from './UserStatus';
import type { UserAttributes } from './UserAttributes';
import {
    UserAttributesFromJSON,
    UserAttributesFromJSONTyped,
    UserAttributesToJSON,
    UserAttributesToJSONTyped,
} from './UserAttributes';

/**
 * 
 * @export
 * @interface UserPutRequest
 */
export interface UserPutRequest {
    /**
     * 
     * @type {UserStatus}
     * @memberof UserPutRequest
     */
    status?: UserStatus;
    /**
     * 
     * @type {number}
     * @memberof UserPutRequest
     */
    rrmThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserPutRequest
     */
    disableRrm?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserPutRequest
     */
    cashbackPercentageTier?: number;
    /**
     * 
     * @type {UserAttributes}
     * @memberof UserPutRequest
     */
    attributes?: UserAttributes;
    /**
     * Whether this user is opted in to auto-save their room rate or not.
     * @type {boolean}
     * @memberof UserPutRequest
     */
    autoSave?: boolean;
    /**
     * Whether this user is opted out of third party advertising or not.
     * @type {boolean}
     * @memberof UserPutRequest
     */
    optOut?: boolean;
    /**
     * Whether this user has enabled mobile push notifications.
     * When true, the user will receive all push notifications.
     * Defaults to false.
     * 
     * @type {boolean}
     * @memberof UserPutRequest
     */
    mobilePushNotifications?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserPutRequest
     */
    iosAppDownloadAt?: string;
    /**
     * 
     * @type {string}
     * @memberof UserPutRequest
     */
    androidAppDownloadAt?: string;
    /**
     * Client IP address from the user's most recent sign-in
     * @type {string}
     * @memberof UserPutRequest
     */
    clientIpAddress?: string;
    /**
     * ISO 4217 currency code for the user's preferred display currency (e.g., USD, EUR, GBP)
     * @type {string}
     * @memberof UserPutRequest
     */
    preferredCurrency?: string;
}



/**
 * Check if a given object implements the UserPutRequest interface.
 */
export function instanceOfUserPutRequest(value: object): value is UserPutRequest {
    return true;
}

export function UserPutRequestFromJSON(json: any): UserPutRequest {
    return UserPutRequestFromJSONTyped(json, false);
}

export function UserPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'] == null ? undefined : UserStatusFromJSON(json['status']),
        'rrmThreshold': json['rrm_threshold'] == null ? undefined : json['rrm_threshold'],
        'disableRrm': json['disable_rrm'] == null ? undefined : json['disable_rrm'],
        'cashbackPercentageTier': json['cashback_percentage_tier'] == null ? undefined : json['cashback_percentage_tier'],
        'attributes': json['attributes'] == null ? undefined : UserAttributesFromJSON(json['attributes']),
        'autoSave': json['auto_save'] == null ? undefined : json['auto_save'],
        'optOut': json['opt_out'] == null ? undefined : json['opt_out'],
        'mobilePushNotifications': json['mobile_push_notifications'] == null ? undefined : json['mobile_push_notifications'],
        'iosAppDownloadAt': json['ios_app_download_at'] == null ? undefined : json['ios_app_download_at'],
        'androidAppDownloadAt': json['android_app_download_at'] == null ? undefined : json['android_app_download_at'],
        'clientIpAddress': json['client_ip_address'] == null ? undefined : json['client_ip_address'],
        'preferredCurrency': json['preferred_currency'] == null ? undefined : json['preferred_currency'],
    };
}

export function UserPutRequestToJSON(json: any): UserPutRequest {
    return UserPutRequestToJSONTyped(json, false);
}

export function UserPutRequestToJSONTyped(value?: UserPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': UserStatusToJSON(value['status']),
        'rrm_threshold': value['rrmThreshold'],
        'disable_rrm': value['disableRrm'],
        'cashback_percentage_tier': value['cashbackPercentageTier'],
        'attributes': UserAttributesToJSON(value['attributes']),
        'auto_save': value['autoSave'],
        'opt_out': value['optOut'],
        'mobile_push_notifications': value['mobilePushNotifications'],
        'ios_app_download_at': value['iosAppDownloadAt'],
        'android_app_download_at': value['androidAppDownloadAt'],
        'client_ip_address': value['clientIpAddress'],
        'preferred_currency': value['preferredCurrency'],
    };
}

